module.exports = __webpack_public_path__ + "static/img/smallapp_preview3.5b8a2c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/preview/smallapp_preview3.png
// module id = iKC6
// module chunks = 1